var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCombinedShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.275 0.75C9.28532 0.75 10.1127 1.50409 10.1827 2.45944L10.1875 2.59091V3.20471H11.4626H12.7375C13.0896 3.20471 13.375 3.47945 13.375 3.81835C13.375 4.12901 13.1352 4.38575 12.824 4.42638L12.7375 4.43198H12.1001V12.4093C12.1001 13.3818 11.3167 14.1781 10.3242 14.2455L10.1876 14.2502H3.81265C2.80233 14.2502 1.97498 13.4961 1.90495 12.5407L1.90015 12.4093V4.43198H1.2625C0.910418 4.43198 0.625 4.15725 0.625 3.81835C0.625 3.50769 0.864831 3.25095 1.17599 3.21031L1.2625 3.20471H2.53765H3.8125V2.59091C3.8125 1.61841 4.59592 0.822034 5.58842 0.754622L5.725 0.75H8.275ZM5.0875 3.20471H8.9125V2.59091C8.9125 2.28025 8.67267 2.02351 8.36151 1.98287L8.275 1.97727H5.725C5.40226 1.97727 5.13553 2.20813 5.09332 2.50764L5.0875 2.59091V3.20471ZM3.17515 4.43198V12.4093C3.17515 12.7199 3.41498 12.9767 3.72614 13.0173L3.81265 13.0229H10.1876C10.5104 13.0229 10.7771 12.792 10.8193 12.4925L10.8251 12.4093V4.43198H3.17515Z",
    fill: "#EE4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombinedShape);
export default __webpack_public_path__ + "static/media/Combined Shape.20823a21c9b52881f4156b39c45a1747.svg";
export { ForwardRef as ReactComponent };